export const SERVICES_DATA = [
  {
    slug: "epoxidharzboeden",
    name: "Epoxidharzböden",
    icon: "Layers",
    featured: true,
    short:
      "Hochwertige Bodenbeschichtungen für Garage, Keller, Werkstatt und Gewerbe – robust, pflegeleicht und in modernen Optiken.",
    h1: "Epoxidharzböden in Gronau (Westf.)",
    seoTitle: "Epoxidharzboden & Bodenbeschichtung Gronau | Terbeck Service",
    metaDescription:
      "Epoxidharzböden in Gronau (Westf.): robuste, pflegeleichte Bodenbeschichtung für Garage, Keller, Werkstatt & Gewerbeflächen. Kostenlose Beratung: 0151 50778186",
    image: "/assets/img/epoxidharzbeschichtung-industrieboden-halle.jpg",
    imageAlt:
      "Epoxidharzbeschichtung in einer Gewerbehalle – großflächiger, glänzender Industrieboden von Terbeck Service, Gronau",
    intro:
      "Ein Boden, der arbeitet und gut aussieht: Terbeck Service beschichtet Garagen, Keller, Werkstätten und Gewerbeflächen mit hochwertigen Epoxidharz-Beschichtungen – robust, fugenlos und in der Optik, die zu Ihrem Raum passt.",
    beschreibung: [
      "Ein Epoxidharzboden ist eine hochwertige, fugenlose Bodenbeschichtung auf Kunstharzbasis. Das Beschichtungssystem wird direkt auf den vorbereiteten Beton- oder Estrichuntergrund aufgebracht und härtet zu einer dichten, belastbaren Oberfläche aus. Das Ergebnis: ein Boden, der die tägliche Beanspruchung zuverlässig trägt und dabei hochwertig aussieht.",
      "Wir beschichten private und gewerbliche Flächen in Gronau (Westf.) und Umgebung im Kreis Borken – von der heimischen Garage bis zur Gewerbehalle. Entscheidend für ein dauerhaft gutes Ergebnis ist die sorgfältige Vorbereitung des Untergrunds. Darauf legen wir besonderen Wert, bevor die eigentliche Beschichtung beginnt.",
    ],
    vorteile: [
      "Robuste, belastbare Oberfläche für den täglichen Gebrauch",
      "Fugenlos und pflegeleicht – einfach zu reinigen",
      "Beständig gegenüber vielen Flüssigkeiten und Verschmutzungen des Alltags",
      "Moderne Optik – verschiedene Farben und Oberflächen möglich",
      "Auf Wunsch mit rutschhemmender Ausführung",
      "Wertet Garagen, Keller und Gewerbeflächen sichtbar auf",
    ],
    surfaces: [
      "Garagen",
      "Keller",
      "Werkstätten",
      "Hobby- & Fitnessräume",
      "Lagerflächen",
      "Verkaufsflächen",
      "Gewerbehallen",
      "Ausstellungsflächen",
    ],
    finishes: [
      "Unifarben – von dezentem Grau bis zu kräftigen Farbtönen",
      "Glänzend oder matt – je nach gewünschter Wirkung",
      "Mit dekorativem Einstreumaterial (Flakes) für eine lebendige Oberfläche",
      "Rutschhemmende Ausführung für Arbeits- und Gewerbeflächen",
    ],
    anwendungsfaelle: [
      "Garage mit hochwertigem, pflegeleichtem Garagenboden aufwerten",
      "Kellerräume zu sauberen Nutz- oder Hobbyräumen machen",
      "Werkstattboden robust und einfach reinigbar beschichten",
      "Lager-, Verkaufs- und Gewerbeflächen mit Industrieboden ausstatten",
    ],
    ablauf: [
      "Anfrage und kostenlose Beratung – telefonisch oder über das Formular",
      "Besichtigung der Fläche und Prüfung des Untergrunds vor Ort",
      "Transparentes Angebot mit festem Preis und Zeitplan",
      "Untergrundvorbereitung und Aufbringen der Beschichtung",
      "Aushärtung und gemeinsame Abnahme der fertigen Fläche",
    ],
    faq: [
      {
        q: "Was kostet ein Epoxidharzboden in Gronau?",
        a: "Der Preis hängt von der Fläche, dem Zustand des Untergrunds und der gewählten Ausführung ab. Nach einer kostenlosen Besichtigung erhalten Sie ein transparentes Festpreisangebot – ohne versteckte Kosten.",
      },
      {
        q: "Wie lange hält eine Epoxidharzbeschichtung?",
        a: "Bei sorgfältiger Untergrundvorbereitung und fachgerechter Ausführung ist eine Epoxidharzbeschichtung sehr langlebig. Die tatsächliche Lebensdauer hängt von der Nutzung der Fläche ab – wir beraten Sie dazu ehrlich und realistisch.",
      },
      {
        q: "Ist ein Epoxidharzboden rutschig?",
        a: "Glänzende Beschichtungen können bei Nässe glatt sein. Für Garagen, Werkstätten und Gewerbeflächen bieten wir auf Wunsch rutschhemmende Ausführungen an – sprechen Sie uns bei der Beratung einfach darauf an.",
      },
      {
        q: "Wie lange dauert die Beschichtung einer Garage oder Halle?",
        a: "Das hängt von Größe und Zustand der Fläche ab. Nach der Besichtigung erhalten Sie einen verbindlichen Zeitplan – inklusive der nötigen Aushärtungszeit, in der die Fläche nicht betreten werden sollte.",
      },
    ],
    gallery: [
      {
        src: "/assets/img/betonboden-vor-beschichtung-werkhalle.jpg",
        alt: "Unbeschichteter Betonboden in einer Werkhalle vor der Epoxidharz-Beschichtung – Ausgangszustand",
      },
      {
        src: "/assets/img/epoxidharzboden-industriehalle-detail.jpg",
        alt: "Detailansicht eines fertig beschichteten Epoxidharzbodens – glänzende, fugenlose Oberfläche nach der Beschichtung",
      },
    ],
    related: ["gebaeudereinigung", "pflasterreinigung", "hausmeisterservice"],
  },
  {
    slug: "hausmeisterservice",
    name: "Hausmeisterservice",
    icon: "Wrench",
    short:
      "Laufende Betreuung, Kleinreparaturen und Pflege für Ihre Immobilie – zuverlässig und aus einer Hand.",
    h1: "Hausmeisterservice in Gronau (Westf.)",
    seoTitle: "Hausmeisterservice Gronau & Kreis Borken | Terbeck Service",
    metaDescription:
      "Hausmeisterservice in Gronau (Westf.): Objektbetreuung, Kleinreparaturen und Pflege für Privat & Gewerbe. Regional & zuverlässig. Angebot: 0151 50778186",
    image: "/assets/img/hausmeisterservice-arbeiten-am-gebaeude.jpg",
    imageAlt:
      "Hausmeisterservice in Gronau – Handwerker bei Instandhaltungsarbeiten an einem Wohngebäude, Terbeck Service",
    intro:
      "Ihre Immobilie in guten Händen: Terbeck Service übernimmt die laufende Betreuung, Pflege und kleine Instandhaltung Ihres Hauses oder Gewerbeobjekts – mit einem festen Ansprechpartner, der Ihr Objekt kennt.",
    beschreibung: [
      "Ein gepflegtes Objekt braucht regelmäßige Aufmerksamkeit. Unser Hausmeisterservice umfasst die laufende Objektbetreuung, kleine Reparaturen, Instandhaltungs- und Pflegearbeiten sowie die Pflege von Grundstück und Außenanlagen – abgestimmt auf Ihr Objekt und Ihren Bedarf.",
      "Ob Einfamilienhaus, Mehrfamilienhaus oder Gewerbeobjekt: Wir erstellen mit Ihnen einen klaren Leistungsumfang, der sich an Ihren Anforderungen orientiert. Sie sparen Zeit, Ihre Immobilie bleibt in Schuss und Sie haben bei Fragen immer denselben Ansprechpartner.",
    ],
    vorteile: [
      "Fester persönlicher Ansprechpartner für Ihr Objekt",
      "Regelmäßige Betreuung nach individuellem Betreuungsplan",
      "Viele Gewerke aus einer Hand – ein Anruf genügt",
      "Faire, transparente Angebote ohne versteckte Kosten",
      "Regional in Gronau und Umgebung – schnell vor Ort",
    ],
    anwendungsfaelle: [
      "Laufende Betreuung von Mehrfamilienhäusern und Wohnanlagen",
      "Objektbetreuung für Gewerbeimmobilien und Büros",
      "Kleinreparaturen und Instandhaltung im und am Haus",
      "Pflege von Grundstück, Wegen und Außenanlagen",
    ],
    ablauf: [
      "Anfrage und kostenloses Erstgespräch – telefonisch oder über das Formular",
      "Besichtigung Ihres Objekts vor Ort in Gronau und Umgebung",
      "Individuelles Angebot mit klar definiertem Leistungsumfang",
      "Regelmäßige Betreuung nach Absprache – zuverlässig und planbar",
    ],
    faq: [
      {
        q: "Was gehört alles zum Hausmeisterservice?",
        a: "Der konkrete Umfang richtet sich nach Ihrem Objekt: typisch sind die laufende Objektbetreuung, kleine Reparaturen, Instandhaltungs- und Pflegearbeiten sowie die Pflege der Außenanlagen. Den genauen Leistungsumfang legen wir gemeinsam in einem Betreuungsplan fest.",
      },
      {
        q: "Betreuen Sie auch Gewerbeobjekte und Wohnanlagen?",
        a: "Ja. Wir betreuen private wie gewerbliche Objekte – vom Einfamilienhaus über Wohnanlagen bis zu Gewerbeimmobilien in Gronau (Westf.) und Umgebung.",
      },
      {
        q: "Kann ich eine regelmäßige Betreuung buchen?",
        a: "Ja, genau das ist unsere Stärke: Wiederkehrende Leistungen vereinbaren wir mit einem festen Betreuungsplan, damit Ihr Objekt dauerhaft gepflegt bleibt, ohne dass Sie sich darum kümmern müssen.",
      },
    ],
    gallery: [
      {
        src: "/assets/img/hausmeister-dachreparatur.jpg",
        alt: "Hausmeisterservice Gronau – Reparaturarbeiten am Dach eines Wohnhauses durch Terbeck Service",
      },
      {
        src: "/assets/img/objektbetreuung-wohnhaus-eingang.jpg",
        alt: "Objektbetreuung in Gronau – gepflegter Eingangsbereich eines deutschen Wohnhauses",
      },
    ],
    related: ["gebaeudereinigung", "epoxidharzboeden", "pflasterreinigung"],
  },
  {
    slug: "gebaeudereinigung",
    name: "Gebäudereinigung",
    icon: "Sparkles",
    short:
      "Professionelle Reinigung von Gebäuden, Fassaden, Einfahrten und Innenbereichen – für Privat und Gewerbe.",
    h1: "Gebäudereinigung in Gronau (Westf.)",
    seoTitle: "Gebäudereinigung Gronau & Kreis Borken | Terbeck Service",
    metaDescription:
      "Gebäudereinigung in Gronau (Westf.): Fassaden, Einfahrten, Wintergärten, Dachrinnen und Innenbereiche professionell reinigen lassen. Angebot: 0151 50778186",
    image: "/assets/img/gebaeudereinigung-professionell-innenbereich.jpg",
    imageAlt:
      "Gebäudereinigung in Gronau – professionelle Reinigung von Innenbereichen und Verkehrsflächen, Terbeck Service",
    intro:
      "Sauber von der Fassade bis zum Innenbereich: Terbeck Service reinigt Gebäude und ihre Außenflächen gründlich und materialschonend – einmalig oder im regelmäßigen Turnus.",
    beschreibung: [
      "Unsere Gebäudereinigung bündelt alles, was an einem Gebäude sauber werden muss: die Fassadenreinigung für einen gepflegten ersten Eindruck, die Reinigung von Einfahrten, Zufahrten und Stellplätzen, die Dachrinnenreinigung als Schutz vor Feuchtigkeitsschäden sowie die Reinigung von Wintergärten und Innenbereichen.",
      "Sie müssen sich nicht um einzelne Gewerke kümmern: Wir stimmen das Vorgehen auf Material und Verschmutzungsgrad ab und erledigen alle Reinigungsarbeiten an Ihrem Gebäude aus einer Hand – für Privathaushalte, Wohnanlagen und Gewerbeobjekte in Gronau (Westf.) und Umgebung im Kreis Borken.",
    ],
    vorteile: [
      "Alle Reinigungsarbeiten am Gebäude aus einer Hand",
      "Materialschonendes Vorgehen bei Fassade, Glas und Belägen",
      "Einmalig oder im regelmäßigen Turnus buchbar",
      "Für Privathaushalte, Wohnanlagen und Gewerbe",
      "Transparente Festpreisangebote nach Besichtigung",
    ],
    anwendungsfaelle: [
      "Fassaden mit Algen-, Moos- oder Witterungsspuren",
      "Einfahrten, Zufahrten und Stellplätze mit Verschmutzungen",
      "Verstopfte Dachrinnen nach dem Laubfall",
      "Wintergärten und Glasflächen innen und außen",
    ],
    ablauf: [
      "Anfrage – gern mit Fotos der zu reinigenden Bereiche",
      "Besichtigung und Abstimmung des Leistungsumfangs vor Ort",
      "Transparentes Festpreisangebot ohne versteckte Kosten",
      "Saubere Durchführung und gemeinsame Abnahme",
    ],
    faq: [
      {
        q: "Welche Bereiche umfasst die Gebäudereinigung?",
        a: "Von der Fassade über Einfahrten und Wege bis zu Dachrinnen, Wintergärten und Innenbereichen: Wir reinigen alle Bereiche Ihres Gebäudes und stimmen das Vorgehen auf das jeweilige Material ab.",
      },
      {
        q: "Kann ich eine regelmäßige Reinigung buchen?",
        a: "Ja. Viele Kunden buchen wiederkehrende Termine – etwa die Fassaden- und Einfahrtsreinigung im Frühjahr oder die Dachrinnenreinigung im Herbst. Wir richten uns nach Ihrem Wunschturnus.",
      },
      {
        q: "Was kostet eine Gebäudereinigung in Gronau?",
        a: "Das hängt von Fläche, Verschmutzungsgrad und Zugänglichkeit ab. Nach einer kurzen Besichtigung – auf Wunsch auch anhand von Fotos – erhalten Sie ein transparentes Festpreisangebot.",
      },
    ],
    gallery: [
      {
        src: "/assets/img/fassadenreinigung-hochdruck.jpg",
        alt: "Fassadenreinigung mit Hochdruck in Gronau – Teil der Gebäudereinigung durch Terbeck Service",
      },
      {
        src: "/assets/img/gepflegte-fassade-modernes-haus.jpg",
        alt: "Gepflegte, saubere Fassade eines modernen Hauses nach der Gebäudereinigung in Gronau",
      },
    ],
    related: ["pflasterreinigung", "epoxidharzboeden", "hausmeisterservice"],
  },
  {
    slug: "pflasterreinigung",
    name: "Pflasterreinigung",
    icon: "Grid3X3",
    short:
      "Moos, Algen und Verschmutzungen gründlich entfernt – für Terrassen, Wege, Einfahrten und Höfe.",
    h1: "Pflasterreinigung in Gronau (Westf.)",
    seoTitle: "Pflasterreinigung Gronau – Terrasse & Wege | Terbeck Service",
    metaDescription:
      "Pflasterreinigung in Gronau (Westf.): Moos, Algen & Verschmutzungen gründlich entfernen – Terrassen, Wege, Einfahrten und Höfe. Angebot: 0151 50778186",
    image: "/assets/img/pflasterreinigung-hochdruck-weg.jpg",
    imageAlt:
      "Pflasterreinigung in Gronau – Reinigung eines gepflasterten Weges mit Hochdruck, Terbeck Service",
    intro:
      "Saubere Pflasterflächen werten jedes Grundstück sofort auf. Terbeck Service reinigt Terrassen, Wege, Einfahrten und Höfe gründlich und entfernt Moos, Algen und hartnäckige Verschmutzungen.",
    beschreibung: [
      "Pflasterflächen sind Witterung und Bewuchs ganzjährig ausgesetzt. Mit der Zeit sammeln sich Moos, Algen und Schmutz in den Fugen – das sieht nicht nur ungepflegt aus, sondern kann auch rutschig werden.",
      "Wir reinigen Ihre Pflasterflächen gründlich und materialschonend – vom Gartenweg über die Terrasse bis zur Einfahrt. Das Ergebnis: ein sauberer, sicherer und gepflegter Außenbereich, auf dem Sie sich wieder wohlfühlen.",
    ],
    vorteile: [
      "Gründliche Entfernung von Moos, Algen und Schmutz",
      "Wieder sichere, rutschfreie Wege und Terrassen",
      "Gepflegter Gesamteindruck Ihres Grundstücks",
      "Materialgerechte Reinigung Ihrer Beläge",
      "Schnelle Terminvergabe in Gronau und Umgebung",
    ],
    anwendungsfaelle: [
      "Terrassen mit Grünbelag und Algen",
      "Garten- und Hofwege mit Moos in den Fugen",
      "Einfahrten, Stellplätze und Höfe",
      "Frühjahrsputz im Außenbereich",
    ],
    ablauf: [
      "Anfrage mit kurzer Beschreibung der Fläche",
      "Besichtigung oder Abstimmung anhand von Fotos",
      "Festpreisangebot ohne versteckte Kosten",
      "Gründliche Reinigung zum Wunschtermin",
    ],
    faq: [
      {
        q: "Was kostet eine Pflasterreinigung?",
        a: "Das hängt von der Fläche und dem Verschmutzungsgrad ab. Schicken Sie uns gern ein Foto Ihrer Fläche oder vereinbaren Sie eine kurze Besichtigung – Sie erhalten anschließend ein transparentes Festpreisangebot.",
      },
      {
        q: "Entfernen Sie auch Moos und Unkraut aus den Fugen?",
        a: "Ja. Moos, Algen und Bewuchs in den Fugen werden bei der Reinigung gründlich entfernt, damit die Fläche wieder sauber und gepflegt aussieht.",
      },
      {
        q: "Reinigen Sie auch Einfahrten und Höfe?",
        a: "Ja, Einfahrten, Zufahrten, Stellplätze und Höfe gehören fest zu unserer Pflasterreinigung – für Privat und Gewerbe in Gronau (Westf.) und Umgebung.",
      },
    ],
    gallery: [
      {
        src: "/assets/img/pflastersteine-detail.jpg",
        alt: "Saubere Pflastersteine im Detail nach der Pflasterreinigung in Gronau",
      },
      {
        src: "/assets/img/gepflegter-gartenweg-pflaster.jpg",
        alt: "Gepflegter Gartenweg aus Pflaster – Ergebnis professioneller Pflasterreinigung",
      },
    ],
    related: ["gebaeudereinigung", "epoxidharzboeden", "hausmeisterservice"],
  },
];

export const getService = (slug) => SERVICES_DATA.find((s) => s.slug === slug);
